/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connector: NonNullable<unknown> }} Agent_Event_Trigger_ConnectInputs */



/**
* | output |
* | --- |
* | "Connect {connector}" |
*
* @param {Agent_Event_Trigger_ConnectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_connect = /** @type {((inputs: Agent_Event_Trigger_ConnectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_ConnectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.connector} verbinden`)
	return /** @type {LocalizedString} */ (`Connect ${i?.connector}`)
});